<template>
  <table class="qrw-simple-table">
      <thead>
          <th>
              Дата
          </th>
          <th>
              Час
          </th>
          <th>
              ID
          </th>
          <th>
              Клієнт
          </th>
          <th>
              Сума
          </th>
          <th>Статус</th>
          <th>
              Вартість доставки
          </th>
      </thead>
      <tbody>
          <tr v-for="preorder in preorders" :key="preorder._id">
            <td>
                {{ preorder.closed_at | formatDate }}
            </td>
            <td>
                {{ preorder.closed_at | formatTime}}
            </td>
            <td>
                {{ preorder.local_id}}
            </td>
            <td>
                {{ preorder.client.name }}
                <br> ({{preorder.client.phone}})
            </td>
            <td>
                {{ preorder.total }} {{currency.code}}
            </td>
            <td>
                <span v-if="preorder.status == 'confirmed'">
                    Нове замовлення
                </span>
                <span class="c-grey" v-else-if="preorder.status == 'serving'">
                    В роботі...
                </span>
                <span class="c-yellow" v-else-if="preorder.status == 'unpaid'">
                    Відправлено
                </span>
                <span class="c-green" v-else-if="preorder.status == 'closed'">
                    Виконано
                </span>
                <span class="c-red" v-else-if="preorder.status == 'cancelled'">
                    Скасовано <br>({{preorder.reason}})
                </span>
            </td>
            <td>
                {{ preorder.delivery_profit}} {{currency.code}}
            </td>
          </tr>
      </tbody>
  </table>
</template>

<script>
import PreorderAPI from '@/api/preorder'

export default {
    data() {
        return {
            preorders: []
        }
    },
    mounted() {
        PreorderAPI.getDeliveryOrders(
            this.$store.state.cafe._id
        ).then(data => {
            this.preorders = data.orders;
        });
    },
    computed: {
        currency() {
            return this.$store.state.currency;
        }
    }
}
</script>

<style>

</style>